import { PulseLoader } from 'react-spinners';
import { ColorHex } from '../../constants';

export interface LoadingDotsProps {
  color?: string;
  size?: number;
}

export const LoadingDots = ({ color, size }: LoadingDotsProps) => {
  return (
    <span className="p-2">
      <PulseLoader
        size={size || 15}
        color={color || ColorHex.natural600}
        loading
      />
      <style>
        {`
        @keyframes react-spinners-PulseLoader-pulse {
          0% {
            transform: scale(1); 
            opacity: 1
          } 
          45% {
            transform: scale(0.1); 
            opacity: 0.7
          } 
          80% {
            transform: scale(1); 
            opacity: 1
          }
        }
        `}
      </style>
    </span>
  );
};
